import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const CandidateDetails = () => {
  const { id } = useParams();
  const [emotions, setEmotions] = useState([]);

  useEffect(() => {
    axios.get(`http://127.0.0.1:5000/emotions/${id}`)
      .then(response => {
        setEmotions(response.data);
      })
      .catch(error => {
        console.error('Error fetching emotions:', error);
      });
  }, [id]);

  return (
    <div>
      <h1>Emotion Data for Candidate {id}</h1>
      <ul>
        {emotions.map(emotion => (
          <li key={emotion.id}>
            {emotion.timestamp}: {emotion.dominant_emotion} ({emotion.age}, {emotion.gender})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CandidateDetails;

